import { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Chip, Stack } from '@mui/material';
import './SelectFilterModal.css';

export default function SelectFilterModal({ selectedFilter, openModal, setOpenModal, addSelectFilter, multiple }) {
    const [value, setValue] = useState([]);
    const [description, setDescription] = useState("");
    const [name, setName] = useState("");
    const [possibleValues, setPossibleValues] = useState([]);

    useEffect(() => {
        if (selectedFilter) {
            setValue([]);
            setDescription(selectedFilter.description);
            setName(selectedFilter.name);
            setPossibleValues(selectedFilter.possibleValues);
        }
    }, [selectedFilter]);


    const handleClose = () => {
        setValue([]);
        setOpenModal(false);
    };

    const toggleSelection = (newValue) => {
        const currentValues = value;
        if (!multiple) {
            setValue([newValue]);
            return;
        }
        if (currentValues.includes(newValue)) {
            setValue(currentValues.filter((value) => value !== newValue));
        }
        else {
            setValue([...currentValues, newValue]);
        }
    }

    const isSelected = (possibleValue) => {
        return value.includes(possibleValue);
    }

    return (
        <>
            <Dialog
                open={openModal}
                onClose={handleClose}
                slotProps={{
                    paper: {
                        component: 'form',
                        onSubmit: (event) => {
                            event.preventDefault();
                            if (value.length > 0) {
                                addSelectFilter({ name: name, value: value, type: "select" });
                            }
                            handleClose();
                        },
                    },
                }}
            >
                <DialogTitle>Filtrer par {name}</DialogTitle>
                <DialogContent className="modal-content">
                    <DialogContentText>
                        {description}
                    </DialogContentText>
                    <Stack direction="row" spacing={1} marginTop="1rem">
                        {possibleValues.map((possibleValue, index) => (
                            <Chip color={isSelected(possibleValue) ? "primary": "default"} key={index} id={possibleValue} label={possibleValue} onClick={() => toggleSelection(possibleValue)} />
                        ))}
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Annuler</Button>
                    <Button type="submit">Ajouter</Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
